import { useMutation, useQuery } from "@tanstack/react-query";

import { n8nInstance } from "@shared/services/api";
import { BACKOFFICE_QUERIES } from "./queries";
import { convertObjectToCamelCase } from "@shared/helpers";

import type { ICompanyPlansBySeller } from "@backoffice/types";

const api = n8nInstance({
  enableBearerToken: true,
  enableXTokenApi: false,
});

export const useGetCompanyPlansBySeller = ({
  companyId,
  filters,
}: {
  companyId?: string | number;
  filters?: any;
}) => {
  const getCompanyPlansBySeller = async (): Promise<{
    success: boolean;
    message: string;
    data?: ICompanyPlansBySeller;
  }> => {
    try {
      const { data } = await api.get(
        `8b833aa6-d2d0-4eb0-bcbd-6e740d0381da/prd/v1/companies/${companyId}/plans`,
        {
          params: { ...filters, default: false },
        },
      );

      return {
        success: true,
        message: "Planos encontrados com sucesso!",
        data: convertObjectToCamelCase(data) as ICompanyPlansBySeller,
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error?.response?.message ||
          "Erro ao buscar planos da empresa!",
      };
    }
  };

  return useQuery({
    queryKey: [BACKOFFICE_QUERIES.COMPANY_PLANS_BY_SELLER, companyId, filters],
    queryFn: () => getCompanyPlansBySeller(),
    enabled: !!companyId,
  });
};


